import { render, staticRenderFns } from "./table-wrapper.vue?vue&type=template&id=492f31b3"
import script from "./table-wrapper.vue?vue&type=script&lang=ts"
export * from "./table-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492f31b3')) {
      api.createRecord('492f31b3', component.options)
    } else {
      api.reload('492f31b3', component.options)
    }
    module.hot.accept("./table-wrapper.vue?vue&type=template&id=492f31b3", function () {
      api.rerender('492f31b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-wrapper.vue"
export default component.exports